import { render, staticRenderFns } from "./app-card.vue?vue&type=template&id=80cb0f00&scoped=true&"
import script from "./app-card.vue?vue&type=script&lang=js&"
export * from "./app-card.vue?vue&type=script&lang=js&"
import style0 from "./app-card.vue?vue&type=style&index=0&id=80cb0f00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80cb0f00",
  null
  
)

export default component.exports